import React, { useState, useEffect } from "react";

import Cal, { getCalApi } from "@calcom/embed-react";

import { RxCross2 } from "react-icons/rx";

const CalComModal = ({ close = () => {}, calLink="boloforms/signature" }) => {
  useEffect(() => {
    (async function () {
      const Cal = await getCalApi();
      Cal("ui", {
        theme: "dark",
        hideEventTypeDetails: false,
      });
    })();
  }, []);

  return (
    <div
      className="fixed top-0 left-0 z-[99999] w-screen h-screen backdrop-blur-md grid place-items-center p-8"
      onClick={close}
    >
      <div className="w-full max-w-screen-lg mx-auto relative">
        <button
          className="z-10 absolute top-0 md:top-6 -right-4 p-2 rounded-full bg-gray-300"
          onClick={close}
        >
          <RxCross2 className="text-2xl text-white" />
        </button>
      </div>

      <Cal
        // calLink="boloforms/signature"
        calLink={calLink}
        style={{ height: "100%", width: "100%" }}
        className="max-w-[calc(100wv-20px)] w-full h-full max-h-[calc(100vh-100px)] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

export default CalComModal;

export const CalComModalTrigger = ({ children, calLink }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {showModal && <CalComModal close={() => setShowModal(false)} calLink={calLink}/>}
      {React.cloneElement(children, {
        onClick: () => setShowModal(true),
      })}
    </>
  );
};
